import React from "react";
import "./ArticleEditTextListItem.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import { ACSTYPE_SEC_TITLE, ACSTYPE_SEC_SUBTITLE } from "../../model/ACSTypes";
import Col from "react-bootstrap/Col";
import { connect } from "react-redux";
import {
  snapShotEditArticleContentAction,
  recoverLastEditArticleContentAction,
  updateArticleContentTextAction,
  saveArticleAction
} from "../../redux/actions/editArticlePanel";
import SelectableEditText from "../SelectableEditText/SelectableEditText";

class ArticleEditTextListItem extends React.Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
  }

  onTextChange(event) {
    const {
      item,
      updateArticleContentTextAction,
      saveArticleAction,
      articleID
    } = this.props;

    updateArticleContentTextAction({ id: item.id, text: event.target.value });
    saveArticleAction(articleID);
  }

  focus() {
    const { item, snapShotEditArticleContentAction } = this.props;
    this.text = item.text;

    snapShotEditArticleContentAction();
  }

  blur() {
    const { item, recoverLastEditArticleContentAction } = this.props;

    if (this.text === item.text) {
      recoverLastEditArticleContentAction();
    }

    this.text = null;
  }

  render() {
    const { item } = this.props;
    const isTitle =
      item.styleType === ACSTYPE_SEC_TITLE ||
      item.styleType === ACSTYPE_SEC_SUBTITLE;

    return (
      <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
        <Row>
          <Col style={{ padding: "5px" }}>
            <SelectableEditText
              onFocus={this.focus}
              //onBlur={this.blur}
              value={
                isTitle
                  ? item.text.replace(/\n/g, "").replace(/<br>/gi, "")
                  : item.text
              }
              onChange={this.onTextChange}
              style={
                isTitle ? { overflow: "scroll", whiteSpace: "nowrap" } : {}
              }
            />
          </Col>
        </Row>
      </Card.Body>
    );
  }
}

const mapDispatch = {
  snapShotEditArticleContentAction,
  recoverLastEditArticleContentAction,
  updateArticleContentTextAction,
  saveArticleAction
};

export default connect(
  null,
  mapDispatch
)(ArticleEditTextListItem);
